export const css = {
	root: '_3cPHXh3Z',
	noSession: 'lPsgzC5d',
	' _key': 'lcc-app/content'
};

export default css;
